import { Component, OnInit, inject, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { PlanificacionCumplimientoService } from '../../../services/planificacion-cumplimiento.service';
import { ListaAspiranteComponent } from "./lista-aspirante/lista-aspirante.component";

@Component({
  selector: 'app-contratacion-aspirante',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, ListaAspiranteComponent],
  templateUrl: './contratacion-aspirante.component.html',
  styleUrl: './contratacion-aspirante.component.css'
})
export class ContratacionAspiranteComponent implements OnInit, AfterViewInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';
  organizaciones: any[] = [];
  isAspirante: boolean = false;
  nombreOrganizacionb: string = '';
  sucursal: string = '';
  datosAspirante: any = [];

  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda

  private srvLogin = inject(InicioService);
  private servicios = inject(PlanificacionCumplimientoService);

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }

  ngAfterViewInit(): void {
    this.mdl.cargando();
    this.servicios.listarOrganizaciones().subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        console.log('prueba:   ',rs.data)
        this.organizaciones = rs.data;
        this.filteredResultado = [...this.organizaciones]; // Actualiza los resultados filtrados al cambiar el año
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }


  // Método para filtrar la tabla
  buscarOrganizacion() {
    this.filteredResultado = this.organizaciones.filter((item: any) => {
      const nombre = item.organizacion ? this.quitarAcentos(item.organizacion.toLowerCase()): '';
      const term = this.searchTerm.toLowerCase();
      return (
        nombre.includes(term)
      );
    });
  }

  litarAspirantes(datos: object, nombre: string, sucursal: string){
    this.nombreOrganizacionb = nombre;
    this.isAspirante = true;
    this.datosAspirante = datos;
    this.sucursal = sucursal;
    //console.table(datos)
  }

  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  voler(eve: any){
    this.isAspirante = eve.value;
  }

}
